import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import {
  MasterIncentiveListRBAC,
  MasterIncentiveAddRBAC,
  MasterIncentiveEditRBAC,
  MasterIncentiveDetailRBAC,
} from './rbac'

const MasterIncentiveList = lazy(() => import('../pages/MasterIncentive'))
const MasterIncentiveAddEdit = lazy(() => import('../pages/MasterIncentiveAddEdit'))
const MasterIncentiveDetail = lazy(() => import('../pages/MasterIncentiveDetail'))

export const MasterIncentiveListRouter: RouterFeatureInterface<
  'MasterIncentiveListRouter',
  '/dashboard/master-incentive'
> = {
  name: 'MasterIncentiveListRouter',
  Component: MasterIncentiveList,
  path: '/dashboard/master-incentive',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterIncentiveListRBAC.pageID,
}

export const MasterIncentiveAddRouter: RouterFeatureInterface<
  'MasterIncentiveAddRouter',
  '/dashboard/master-incentive/add'
> = {
  name: 'MasterIncentiveAddRouter',
  Component: MasterIncentiveAddEdit,
  path: '/dashboard/master-incentive/add',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterIncentiveAddRBAC.pageID,
}

export const MasterIncentiveEditRouter: RouterFeatureInterface<
  'MasterIncentiveEditRouter',
  '/dashboard/master-incentive/edit/:id'
> = {
  name: 'MasterIncentiveEditRouter',
  Component: MasterIncentiveAddEdit,
  path: '/dashboard/master-incentive/edit/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterIncentiveEditRBAC.pageID,
}

export const MasterIncentiveDetailRouter: RouterFeatureInterface<
  'MasterIncentiveDetailRouter',
  '/dashboard/master-incentive/detail/:id'
> = {
  name: 'MasterIncentiveDetailRouter',
  Component: MasterIncentiveDetail,
  path: '/dashboard/master-incentive/detail/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterIncentiveDetailRBAC.pageID,
}

const IncentiveRouter = [
  MasterIncentiveListRouter,
  MasterIncentiveAddRouter,
  MasterIncentiveEditRouter,
  MasterIncentiveDetailRouter,
]

export const IncentiveRouterDetail = generateRouterDetail(IncentiveRouter)
export default IncentiveRouter
